import React, { useState } from "react";
import { AsidebarStore } from "(store)/AsidebarStore";
import { MenuSideBarIcon } from "assets/icons";
import { NotificationWidget, ProfileDropdown } from "components";

const Menubar = () => {
  const { isSideBarOpen, setIsSideBarOpen } = AsidebarStore();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown")) {
      setIsDropdownOpen(false);
    }
  };

  document.body.onclick = handleOutsideClick;

  return (
    <div className="w-full h-[80px] flex items-center shadow-md border-b-2 border-slate-400 dark:border-gray-800 relative">
      <div className="h-full text-[#1467b0] flex items-center px-5 flex-shrink-0 lg:hidden">
        <MenuSideBarIcon
          className={"cursor-pointer"}
          width={40}
          onClick={() => setIsSideBarOpen(!isSideBarOpen)}
        />
      </div>

      <div className="w-auto ml-auto mr-6 h-full flex items-center justify-around gap-8">
        <div>
          <NotificationWidget />
        </div>
        
        <div className="dropdown">
          <ProfileDropdown
            onClick={() => setIsDropdownOpen((prev) => !prev)}
            isOpen={isDropdownOpen}
            user={{ name: "Mohammad Tahir", image: "" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Menubar;
